export default "__VITE_ASSET__Bbl4Sczp__"